import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { CanActivateFn } from '@angular/router';
import { SSR_CONTEXT } from './ssr-context';

export const notFoundGuard: CanActivateFn = () => {
    const ctx = inject(SSR_CONTEXT, { optional: true });
    if (ctx && isPlatformServer(inject(PLATFORM_ID))) {
        ctx.status = 404;
    }
    return true;
};